import { SurgicalOrderRecommendationRepository as ISurgicalOrderRecommendationRepository } from 'repository/interfaces/surgical-order-recommendation-repository'
import { IApiRepository } from 'service/protocols/api/api-repository'
import { GetProceduresRecommendations } from 'domain/usecases/surgical-order-recommendation/get-procedures-recommendations'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import { CustomError } from 'common/errors'

export class SurgicalOrderRecommendationRepository
  implements ISurgicalOrderRecommendationRepository
{
  constructor(private readonly apiRepository: IApiRepository) {}

  async getProceduresRecommendations(
    params: GetProceduresRecommendations.Params
  ): Promise<GetProceduresRecommendations.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<GetProceduresRecommendations.Model>

    const httpResponse: any = await apiRepository.get({
      url: '/api/recommendations',
      params
    })

    if (
      httpResponse.statusCode &&
      httpResponse.statusCode !== ApiStatusCode.ok
    ) {
      throw new CustomError('Ocorreu um erro ao buscar recomendações')
    }

    return httpResponse.body as GetProceduresRecommendations.Model
  }
}
